import { type BidState } from 'features/bids/bid.slice'
import { type VendorState } from 'features/vendor/vendor.slice'
import { type VendorListState } from 'features/vendors/vendorList.slice'
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { type AnyAction, type Dispatch, type ThunkDispatch } from '@reduxjs/toolkit'
import { type AuthState } from 'common/authentication/auth.slice'

import { type AppState } from './app.slice'

import type { RootState, AppDispatch } from './store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = (): ThunkDispatch<
  {
    app: AppState
    auth: AuthState
    vendor: VendorState
    bid: BidState
    vendorList: VendorListState
  },
  undefined,
  AnyAction
> &
  Dispatch => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
